import { useRef, useCallback } from 'react';
import { scrollToElement } from 'src/utils/common';

export const useScrollToElement = (offset = 0) => {
  const containerRef = useRef<HTMLDivElement>(null);

  const scrollTo = useCallback(
    (elementId: string) => {
      scrollToElement(elementId, containerRef, offset);
    },
    [offset]
  );

  return { containerRef, scrollTo };
};